<template>
  <div class="container" :class="{ 'selected': multiCardClicked === number }">
    <div class="top-row">
      <div class="number">
        <span>
          {{ tr('Sample ') }}
        </span>
        <span>
          {{ props.number }}
        </span>
      </div>
      <div class="date">
        <span>{{ formatDate(date) || '—' }}</span>
      </div>
    </div>
    <div class="datum">
      <!-- TODO: reenable when we have the correct source <span class="label">{{ tr('Diagnosis Reported') }}</span>
      <span>{{ diagnosis || '—' }}</span> -->
    </div>
    <div class="datum" title="TMB">
      <span class="label">{{ tr('TMB') }}</span>
      <span id="tmb-value">{{ tmb }}</span>
    </div>
    <div class="datum" title="MSI">
      <span class="label">{{ tr('MSI') }}</span>
      <span id="msi-value">{{ msi }}</span>
    </div>
    <div class="location">
      <span class="material-symbols-outlined size-20">
        location_on
      </span>
      <span class="location-text">{{ labName || '—' }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineProps, onMounted, ref } from 'vue'
import { getTmbMsi } from '../getGenomicsData.js'
import { formatDate } from '@/utils/utils'
import { store } from '@/store'
const useNewOmicsApi = store.getters.featureToggles.useNewOmicsApi

const tr = (x) => x // inject('tr')

const props = defineProps({
  number: {
    type: Number,
    default: 0,
  },
  date: {
    type: String,
    default: '',
  },
  diagnosis: {
    type: String,
    default: '',
  },
  multiCardClicked: {
    type: Number,
    default: -1,
  },
  sampleId: {
    type: String,
    default: '',
  },
  labName: {
    type: String,
    default: '',
  },
  tmb: {
    type: String,
    default: '',
  },
  msi: {
    type: String,
    default: '',
  },
  selected: Boolean,
})

const DEFAULT_MSI_TEXT = 'No clinically significant MSI'
const DEFAULT_TMB_TEXT = 'No clinically significant TMB'

//At the moment, props for new genomics API, refs for old which we make calls for directly
const msiRef = ref('')
const tmbRef = ref('')
const msi = computed(() => props.msi || msiRef.value || DEFAULT_MSI_TEXT)
const tmb = computed(() => props.tmb || tmbRef.value || DEFAULT_TMB_TEXT)
const labName = computed(() => props.labName)
// TODO: reenable when we have the correct source for this
// const diagnosis = computed(() => props.diagnosis)

const getTMBMSI = async () => {
  //MSI
  const msiResults = await getTmbMsi(props.sampleId, 'MSI')
  msiRef.value = msiResults.results && msiResults.results[0]?.value ? msiResults.results[0].value : DEFAULT_MSI_TEXT

  //TMB
  const tmbResults = await getTmbMsi(props.sampleId, 'TMB')
  tmbRef.value = tmbResults.results && tmbResults.results[0]?.value ? tmbResults.results[0].value : DEFAULT_TMB_TEXT
}

onMounted(async () => {
  if (!useNewOmicsApi) { await getTMBMSI() }
})

</script>

<style lang="scss" scoped>
.container {
  font-size: 0.7rem;
  border-radius: 10px;
  background-color: var(--Grey100);
  overflow: auto;
  text-align: left;
  margin: 1rem 0.5rem 0;
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: calc(26vh - 6rem);

  &:hover {
    cursor: pointer;
    background-color: var(--Grey100);
    box-shadow: 5px 5px 5px var(--Grey500);
    transition: all ease-out 200ms;
  }
}

.date {
  margin-left: 0.2rem;
  background-color: var(--Grey300);
  padding: 0.2rem;
  border-radius: 4px;
}

.datum {
  margin: 0 1rem 0.5rem;
  display: flex;
  flex-direction: column;
}

.location {
  margin: 0 0.8rem 0.1rem;
  color: var(--Grey500);
  display: flex;
  flex-direction: row;
  font-size: 0.7rem;
}

.location-icon {
  padding-bottom: 3px;
}

.location-text {
  padding-top: 3px;
}

.number {
  margin-right: 10px;
  background-color: #e9ffaa;
  width: max-content;
  border-radius: 4px;
  padding: 4px;
  text-align: center;
  height: 98%
}

.selected {
  border: 2px solid var(--Primary);
}

.top-row {
  display: flex;
  margin: 0.5rem 1rem 0.5rem;
  justify-content: flex-start;
  flex-basis: auto;
  align-items: center;
}
</style>
